import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'appFilter'
})
export class AppFilter implements PipeTransform {

  transform(items: any[], ...args: any[]): any[] {
    if (!items || !items.length) {
      return [];
    }
    if (!args || !args.length) {
      return items;
    }

    if (args.length = 1) {
      // return items.filter(e => args[0] == e);
    }

    const keys = Object.keys(args[0]);

    // console.log('appFilter', args, keys);
    const itms = items.filter(obj => {
      let result = null;
      for (let i = 0; i < keys.length; i++) {
        const value = Objectifier.get(keys[i], false, obj);
        if (value && args[0][keys[i]]) {
          const searchText = args[0][keys[i]].toLowerCase();
          if (searchText && searchText.length > 0) {
            if (value.toLowerCase().includes(searchText)) {
              result = obj;
            }
          } else {
            result = obj;
          }
        } else {
          result = obj;
        }
      }
      return result;
    });
    // console.log('itms', itms);
    return itms;
  }
}


const Objectifier = (function () {

  // Utility method to get and set objects that may or may not exist
  const objectifier = function (splits, create, context) {
    let result = context || window;
    for (let i = 0, s; result && (s = splits[i]); i++) {
      result = (s in result ? result[s] : (create ? result[s] = {} : undefined));
    }
    return result;
  };

  return {
    // Creates an object if it doesn't already exist
    set: function (name, value, context) {
      const splits = name.split('.'), s = splits.pop(), result = objectifier(splits, true, context);
      return result && s ? (result[s] = value) : undefined;
    },
    get: function (name, create, context) {
      return objectifier(name.split('.'), create, context);
    },
    exists: function (name, context) {
      return this.get(name, false, context) !== undefined;
    }
  };

})();



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/filter.pipte.ts